import { autoinject, Container } from "aurelia-dependency-injection";
import { AlertsCourtModel } from "../models/alerts-court";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsCourtView } from "./alerts-court";
import { AlertsModel } from "../models/alerts";
import { AlertsCourtListView } from "./alerts-court-list";
import { AppEvents } from "../../app-events";
import { AppUser } from "../../authentication/app-user";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-courts.html");

const dom = {
    THINKER: ".thinker",
    CONTENT: ".alert-content",
    JURISDICTION_FILTER: "#jurisdictions-filter",
    JURISDICTION_FILTER_OPTION: ".jurisdiction-filter-option",
    JURISDICTION_FILTER_CLEAR: "#court-alert-clear-filter",
    ALERT_SIGNIN_OVERRIDE: ".alert-override-link",
    MESSAGE: ".alerts-message"
};

@backboneViewProperties({
    template: template
})

export class AlertsCourtsView extends Marionette.LayoutView<AlertsModel> {
    private user: AppUser;
    private courtListRegion: Marionette.Region;
    private listView: AlertsCourtListView;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.user = options.user;
        this.setupModelListeners();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["change " + dom.JURISDICTION_FILTER] = (e) => this.filterListRegion(e);
        events["click " + dom.JURISDICTION_FILTER_CLEAR] = (e) => this.clearFilter(e);
        events["click " + dom.ALERT_SIGNIN_OVERRIDE] = (e) => this.overrideLinkClick(e);
        return events;
    }

    public regions(): any {
        const regions: any = {
            courtListRegion: "#alerts-court-list-region"
        };
        return regions;
    }

    public async onShow() {
        this.updateInterface();
    }

    private updateInterface() {
        this.$(dom.MESSAGE).empty();
        if (this.user.Sku.toLowerCase() === "free") {
            this.displayFreeUserMessage();
        } else if (this.user.Sku.toLowerCase() === "open") {
            this.displayOpenUserMessage();
        } else if (this.user.AuthenticatedByIp) {
            this.displayPersonalSignInMessage();
        } else if (this.user.isAcademicUser) {
            this.displayNoEmailMessage();
        } else if (!this.user.Email) {
            this.displayNoEmailMessage();
        } else {
            this.model.fetchCourtData().then((data) => {
                this.model.CourtAlerts.set(data);
                this.setupListRegion();
                this.setupJurisdictionsFilter();
            }, () => {
                this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to retrieve court alerts. Please try again.");
                this.$(dom.THINKER).toggle(false);
            }).catch((exception) => {
                if (!this.isDestroyed) {
                    this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to retrieve court alerts. Please try again.");
                    this.$(dom.THINKER).toggle(false);
                }
            });
        }
    }

    private overrideLinkClick(e) {
        e.stopPropagation();
        e.preventDefault();
        const returnUrl = window.location.pathname;
        const signinUrl = `override?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private displayFreeUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but alerts are only available to subscribed users. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayOpenUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but alerts are not available in your subscriptions. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayPersonalSignInMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but alerts are only available to signed in users. Please <a class="alert-override-link" href="override" data-command="signin" style="color:#fdb813">sign in as a personal user</a> to see your alerts.</p>`);
    }

    private displayNoEmailMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but an email is required to set up alerts.</p>`);
    }

    private hideContent() {
        this.$(dom.THINKER).hide();
        this.$(dom.CONTENT).hide();
    }

    private setupListRegion() {
        this.listView = new AlertsCourtListView({collection: this.model.CourtAlerts});
        this.courtListRegion.show(this.listView);
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Loaded", this.onChangeLoaded);
        this.listenTo(this.user, "refresh", this.updateInterface);
    }

    private onChangeLoaded(model, property) {
        this.$(dom.THINKER).toggle(!property);
        this.$(dom.CONTENT).toggle(property);
     }

    private setupJurisdictionsFilter() {
        this.populateJurisdictionsFilter();
    }

    private populateJurisdictionsFilter() {
        const disabledOpt = $("<option disabled='true' selected='true'>Filter by jurisdiction</option>");
        this.$(dom.JURISDICTION_FILTER).append(disabledOpt);

        const jurisdictions = new Set(this.model.CourtAlerts.map((ca) => ca.DisplayJurisdiction));

        for (const jur of Array.from(jurisdictions).sort()) {
            const opt = $(`<option value="${jur}" class="jurisdiction-filter-options" >${jur}</option>`);
            this.$(dom.JURISDICTION_FILTER).append(opt);
        }
    }

    private filterListRegion(e: JQueryEventObject) {
        _.defer(() => {
            const filter = $(e.currentTarget).val();
            const visible = this.model.CourtAlerts.filter((a) => a.DisplayJurisdiction === filter);
            this.listView.collection = new Backbone.Collection(visible);
            this.listView.render();
            this.$(dom.JURISDICTION_FILTER_CLEAR).show();
        });
    }

    private clearFilter(e: JQueryEventObject) {
        e.preventDefault();
        e.stopPropagation();

        this.$(dom.JURISDICTION_FILTER).empty();
        this.populateJurisdictionsFilter();
        this.setupListRegion();
        this.$(dom.JURISDICTION_FILTER_CLEAR).hide();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-courts.ts